/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS11 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_10;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_11;
    },
    getDownloadName() {
      return ns.IOS11.nice_name;
    },
  });

  Object.assign(IOS11, {
    slug: `ios_11`,
    nice_name: `iOS 11 adoption`,
    description: `How quickly are consumers upgrading to iOS 11?`,
  });
  ns.IOS11 = IOS11;
});

}.call(window));